import React from "react";

import { localizeDateMed, localizeTimeShort } from "utils/dateFormats";

const AppTableDateTime = ({ date, dateOnly = false }) => {
  if (!date) return "N/A";

  return (
    <div className="text-center">
      <div className="text-sm"> {localizeDateMed(date)}</div>
      {!dateOnly && (
        <div className="text-xs text-gray-500 dark:text-gray-300">
          {date && localizeTimeShort(date)}
        </div>
      )}
    </div>
  );
};

export default AppTableDateTime;
